export default __webpack_public_path__ + "static/media/home-img.38d671ac.svg";